const departmentList = {
    tableList: [
        {
            'id': 1,
            'text': 'No',
            'name':'sNo',
            'visible': true,
            'className': 'text-center'
        }, 
        // {
        //     'id': 2,
        //     'text': 'Unit',
        //     'visible': true,
        //     'className': null
        // }, {
        //     'id': 3,
        //     'text': 'Unit Location',
        //     'visible': true,
        //     'className': null
        // },
        
        {
            'id': 4,
            'text': 'Department',
            'name':'name',
            'visible': true,
            'className': null
        }, {
            'id': 5,
            'text': 'Department Code',
            'name':'id',
            'visible': true,
            'className': null
        }, {
            'id': 6,
            'text': 'Status',
            'name':'status',
            'visible': true,
            'className': null
        }, {
            'id': 7,
            'text': 'Action',
            'name':'action',
            'visible': true,
            'className': null
        }
    ]
};

const departmentForm = {
    feilds: [{
        id: 0,
        name: 'newUnit',
        text: 'Add New Departement',
        visible: true,
        element: 'label',
        className: [],
        required: false
    }, {
        id: 1,
        name: 'name',
        text: 'Enter Department Name',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter Department Name',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return  (value !== null && value.length > 0);
                },
                message: 'Please Enter Your Department Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: []
    },  {
        id: 0,
        name: 'button',
        text: 'Departement',
        visible: true,
        required: false,
        element: 'button',
        input_type: 'button',
        disable: false
    }]
}

export {departmentList, departmentForm};